module.exports = __webpack_public_path__ + "images/load-icon.f35eda5638cc6cf04fe29669c2c80d3e.png";